/**
 * _Modal.js
 */

import $ from 'jquery';
import Utilities from './Utilities';
import flatpickr from "flatpickr";
import moment from 'moment';
import { trapFocus, removeTrapFocus } from '@shopify/theme-a11y'

class Modal {

    constructor() {

        $('.book-now-trigger').on('click', function (e) {
            e.preventDefault();
            $('.booking-modal').addClass('active');
            $('html').addClass('locked');
            trapFocus($('.booking-modal')[0], {
                elementToFocus: $('.modal-close-wrapper')
            });
        })

        $('.modal-close-wrapper').on('click', function () {
            $('.booking-modal').removeClass('active');
            $('html').removeClass('locked');
            removeTrapFocus($('.booking-modal')[0]);
        })

        flatpickr('#modal-input', {
            mode: "range",
            inline: true,
            minDate: "today",
            dateFormat: "m/d/Y",
            nextArrow: '<i class="icon-arrow-right"></i>',
            prevArrow: '<i class="icon-arrow-left"></i>',
            onChange: function (selectedDates, dateStr, instance) {
                var checkInDate = moment(selectedDates[0]).format('L');
                var checkOutDate = moment(selectedDates[1]).format('L');

                // If the check out date isn't selected checkout date is automatically set to the day after check-in date.
                if ( selectedDates[1] == null || selectedDates[0]> selectedDates[1] ) {
                    checkOutDate = moment(selectedDates[0]).add(1, 'days').format('L');
                }

                $('.date-in').val(checkInDate);
                $('.date-out').val(checkOutDate);

            },
        });

        setTimeout(function () {
            $('.flatpickr-calendar').attr({'tabindex': 0, 'aria-label': 'Select Dates'});
        }, 300)
    }

}
new Modal();
